var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid -page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h2',[_vm._v(_vm._s(_vm.$route.name))]),_c('p',[_vm._v("soon..")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }